import script from "./ClientRolePropertiesDialog.vue?vue&type=script&setup=true&lang=js"
export * from "./ClientRolePropertiesDialog.vue?vue&type=script&setup=true&lang=js"

import "./ClientRolePropertiesDialog.vue?vue&type=style&index=0&id=5d7a6284&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5d7a6284"]])

export default __exports__